import { render, staticRenderFns } from "./FeeTaxType.vue?vue&type=template&id=6ab5ba5e&scoped=true&"
import script from "./FeeTaxType.vue?vue&type=script&lang=js&"
export * from "./FeeTaxType.vue?vue&type=script&lang=js&"
import style0 from "./FeeTaxType.vue?vue&type=style&index=0&id=6ab5ba5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab5ba5e",
  null
  
)

export default component.exports